import { useTranslation } from "react-i18next";

import { IconClipboardPlus, IconPlus } from "@pentabd/icons";
import { Button, Header } from "@pentabd/ui";
import { ROUTES } from "@constants/routes";
import { useLanguage } from "@hooks/useLanguage";
import { useNavigate } from "react-router-dom";

type Props = {
  procurementData: any;
};

const { INVENTORY, CREATE } = ROUTES;
const { PRODUCTS } = INVENTORY;

const ProcurementsDetailsPageHeader = ({ procurementData }: Props) => {
  const { procurementsState } = procurementData;
  const { getSingleData } = procurementsState;

  const { t } = useTranslation();
  const { language } = useLanguage();

  const navigate = useNavigate();

  const breadcrumbs = [
    {
      icon: <IconClipboardPlus fill="dark" size="20" />,
    },
    {
      label: t("SIDEBAR.INVENTORY.REGISTER.PROCUREMENTS"),
      link: ROUTES.INVENTORY.PROCUREMENTS,
    },
    {
      label: language === "bn" ? getSingleData?.nameBn : getSingleData?.nameEn,
    },
  ];

  const headerText = {
    header: `${t("SIDEBAR.INVENTORY.REGISTER.PROCUREMENTS")}: ${
      language === "bn" ? getSingleData?.nameBn : getSingleData?.nameEn
    }`,
  };

  return (
    <Header
      headerText={headerText}
      breadcrumbs={breadcrumbs || []}
      actions={
        getSingleData?.procurementType === null ||
        getSingleData?.procurementType === "PROCUREMENT_PRODUCT"
          ? [<></>]
          : [
              // <Link to={`${ROUTES.BATCH_CREATE}`}>
              //   <Button fill="outline" type="primary" size="xs">
              //     <IconPlus fill="primary" size="17" />
              //     {t("PROCUREMENTS_DETAILS.ADD_PRODUCT_BATCH")}
              //   </Button>
              // </Link>,
              <Button
                fill="fill"
                type="primary"
                size="xs"
                onClick={() => navigate(`${CREATE}${PRODUCTS}`)}
              >
                <IconPlus fill="light" size="17" />
                {t("PROCUREMENTS_DETAILS.ADD_PRODUCT")}
              </Button>,
            ]
      }
    />
  );
};

export default ProcurementsDetailsPageHeader;
